'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$12() {
  this.baU = null;
  this.baV = false;
}
export { $c_Lpresto_Presto$$anon$12 as $c_Lpresto_Presto$$anon$12 };
$p = $c_Lpresto_Presto$$anon$12.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$12;
/** @constructor */
function $h_Lpresto_Presto$$anon$12() {
}
export { $h_Lpresto_Presto$$anon$12 as $h_Lpresto_Presto$$anon$12 };
$h_Lpresto_Presto$$anon$12.prototype = $p;
$p.P = (function() {
  if ((!this.baV)) {
    this.baU = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T4($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$().aD()), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$().aD()));
    this.baV = true;
  }
  return this.baU;
});
var $d_Lpresto_Presto$$anon$12 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$12, "presto.Presto$$anon$12", ({
  N8: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_Presto$$anon$12 as $d_Lpresto_Presto$$anon$12 };
//# sourceMappingURL=presto.-Presto$$anon$12.js.map
